import {inject, Injectable} from '@angular/core';
import {UserPreferencesService} from "../user-preferences.service";
import {ColumnProfile} from "../../types/user-preferences.types";

@Injectable({
  providedIn: 'root'
})
export class ActiveColumnProfileService {
  private userPreferencesService: UserPreferencesService = inject(UserPreferencesService);

  public updateActiveColumnProfile(columnProfileName: string): ColumnProfile | undefined {
    const columnProfiles = this.userPreferencesService.getUserPreferences()?.columnProfiles;
    if (!columnProfiles?.length) { return; }

    const currentActive = columnProfiles.find(columnProfile => columnProfile.isActive);
    const newActiveProfile = columnProfiles.find(columnProfile => columnProfile.profileName === columnProfileName);

    if (!currentActive || !newActiveProfile) { return; }
    currentActive.isActive = false;
    newActiveProfile.isActive = true;

    this.userPreferencesService.saveUserPreferences({ columnProfiles });
    return newActiveProfile;
  }
}
